// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceYourRoom_root__N8WTz","sectionContainer":"PlaceYourRoom_sectionContainer__wYnuo"};